<template>
    <div>
        <v-select :disabled="note.archived || !userCanEdit" v-model="$form.note.type" :options="$select('note_type')" disable-search/>
        <textarea-field :disabled="note.archived || !userCanEdit" v-model="$form.note.text" class="my-2"/>

        <div v-if="$form.note.type == 2" class="mb-4">
            <alert theme="danger" v-if="fileError">
                Für diesen Notiz-Typ muss eine Datei hochgeladen werden.
            </alert>
            <div v-if="$form.note.file">
                <a :href="fileUrl" target="_blank">{{ $form.note.file.name }}</a>
            </div>

            <upload label="Datei hochladen"
                    upload-action="upload/upload"
                    @input="handleUpload"
                    @error="handleUploadError"
            />
        </div>

        <div class="mb-2" v-if="userCanEdit">
            <btn v-if="!note.archived"
                 v-disabled="checkSubmitButtonDisabled()"
                 theme="success"
                 size="sm"
                 class="mr-2"
                 label="Speichern"
                 @click="$form.$submit"
            />
            <btn v-if="!note.archived"
                 class="mr-2"
                 theme="secondary"
                 size="sm"
                 label="Archivieren"
                 @click="handleArchiveNote(true)"
                 confirm="Soll diese Notiz wirklich archiviert werden?"
            />
            <btn v-if="note.archived"
                 class="mr-2"
                 theme="secondary"
                 size="sm"
                 label="Wiederherstellen"
                 @click="handleArchiveNote(false)"
            />
            <btn theme="danger"
                 size="sm"
                 label="Löschen"
                 @click="handleDeleteNote()"
                 confirm="Soll diese Notiz wirklich gelöscht werden?"
            />
        </div>
    </div>
</template>

<script>
    import {required} from 'vuelidate/lib/validators';

    export default {
        name: "EditNoteForm",

        props: {
            note: {type: Object, required: true},
        },

        data() {
            return {
                fileError: false,
            };
        },

        computed: {
            fileUrl() {
                return `/api/file/content/${btoa(this.$form.note.file.id_file)}`;
            },

            userCanEdit() {
                return this.$can('note.edit_all') || this.$store.getters['auth/getUser'].id_user === this.note.id_creator;
            },
        },

        form: {
            getter() {
                return {note: this.note};
            },

            validations: {
                note: {
                    type: {required},
                    text: {required},
                },
            },

            async action(data) {
                let note = data.note;
                if (note.type === 2 && !note.file) {
                    this.fileError = true;
                    return false;
                }
                if (note.type !== 2) {
                    note.file = null;
                }

                let requestResult = await this.$store.dispatch((data.note.id_user === null ? 'backend' : 'community') + '/createOrSaveNote', note);

                if (!requestResult.$success) {
                    this.$notify.danger({body: requestResult.message || 'Ein unerwarter Fehler ist aufgetreten', timeout: 5});
                    return false;
                }
            },
        },

        methods: {
            handleUpload(file) {
                this.$form.note.file = file;
                this.fileError = false;
            },

            handleUploadError(type) {
                let message;
                switch (type) {
                    case 'max-size': message = 'Die ausgewählte Datei hat nicht das richtige Format.'; break;
                    case 'format': message = 'Die ausgewählte Datei ist zu groß. Die Maximale Dateigröße beträgt 5 MB.'; break;
                    default: message = 'Beim Hochladen der Datei ist ein Fehler aufgetreten. Probiere es bitte später erneut.'; break;
                }
                this.$notify.danger({body: message, timeout: 5});
            },

            async handleDeleteNote() {
                let data = await this.$store.dispatch('community/deleteNote', this.$form.note);

                if (!data.$success) {
                    this.$notify.danger({body: data.message || 'Ein unerwarter Fehler ist aufgetreten', timeout: 5});
                }
            },

            async handleArchiveNote(newValue) {
                let archivedNote = this.$form.note;

                archivedNote.archived = newValue;

                let requestResult = await this.$store.dispatch('community/createOrSaveNote', archivedNote);

                if (!requestResult.$success) {
                    this.$notify.danger({body: requestResult.message || 'Ein unerwarter Fehler ist aufgetreten', timeout: 5});
                    return false;
                }
            },

            checkSubmitButtonDisabled() {
                if (!this.$form.$isDirty) {
                    return true;
                }
                if (this.$form.note.type === 2 && !this.$form.note.file) {
                    return true;
                }
                return false;
            },
        },
    };
</script>

<style lang="scss">
    .edit-note-modal {
        .text-area {
            min-height: 80px;
        }
    }
</style>